import { MDBIcon } from "mdb-react-ui-kit";
import ContactUsForm from "./ContactUsForm";
import { useState } from "react";
import { Modal } from "react-bootstrap";


function ContactBtn(props){
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return(
        <>
    <div className="d-flex justify-content-center">
        <button className="blue-btn" onClick={handleShow}><MDBIcon className="icon-play" fas icon="play" />Get Started Now !</button>
    </div>
          {/* contact */}
          <Modal 
        size='md'
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <button className='btn-close float-end text-dark' onClick={handleClose} ></button>
          <ContactUsForm handleClose={handleClose} />
        </Modal.Body>
      </Modal>
        </>
    )

}

export default ContactBtn;